import appPackage from "../../package.json";
export default {
	isBeta: !!appPackage.version?.endsWith("beta"),
	meta: {
		youtube: "https://www.youtube.com/channel/UCC7heWfWw-9TklQp49pKWtw",
		apiDocs: "https://app.swaggerhub.com/apis-docs/timeghost/timeghost",
		teams: "https://teams.microsoft.com/l/app/e3956558-7399-4ec1-848a-c61a2aa95bc1",
	},
};
